import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=465c2f3f&"
import script from "./landing-page.vue?vue&type=script&lang=js&"
export * from "./landing-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports